import styled, { css } from 'styled-components';

import Picture from 'components/picture';

export const Image = styled(Picture)<{ $idx: number }>`
  flex: 1 0;
  border-radius: 0;
  width: 100%;
  height: 100%;
  img {
    z-index: ${Styles.zIndex.below};
  }
`;

export const Card = styled.div<{ $inactive?: boolean }>`
  display: flex;
  flex-direction: column;
  height: 10.5rem;
  width: 8.75rem;
  flex-shrink: 0;
  overflow: hidden;
  background-color: ${Styles.color.white};
  border-radius: ${Styles.borderRadius};
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  text-decoration: none;
  transition: 0.25s;
  ${p =>
    p.$inactive &&
    css`
      ${Image} {
        border-color: ${Styles.color.primary};
        background-color: ${Styles.color.primary};
      }
    `}
  ${Styles.desktop`
      box-shadow: unset;
      width: 11.25rem;
    `};
`;

export const Label = styled.h2`
  padding: 0.6rem 0.75rem;
  font-size: 1rem;
  font-weight: bold;
  margin: 0;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  ${Styles.desktop`
    font-size: 1.1rem;
    line-height: 1.5;
  `}
`;
